export class AiModelsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiModels({ signal, ...params } = {}) {
    return this.#http.get('/ai-models', { params, signal });
  }

  async syncAiModels() {
    return this.#http.post('/ai-models/sync');
  }
}
